import { useEffect, useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { dateFormat } from "../../../util/DateUtil";
import TextFieldDate from "../../UI/TextFieldDate";

const ymd = (data) => moment.utc(data).format("YYYY-MM-DD");

/** Diálogo de cadastro/edição da quantidade de aulas de um dia. */
const CronogramaQuantAulaDiaForm = ({ cqad, bimestre, onClose, onSave, isSaving }) => {
  const [data, setData] = useState(null);
  const [dataAlterada, setDataAlterada] = useState(false);
  const [quantAulas, setQuantAulas] = useState("");

  useEffect(() => {
    if (!cqad) return;
    // O servidor guarda a data em UTC; usa o dia UTC para não exibir o dia anterior.
    setData(cqad.data ? dayjs(ymd(cqad.data)) : null);
    setDataAlterada(false);
    setQuantAulas(cqad.quantAulas === null || cqad.quantAulas === undefined ? "" : String(cqad.quantAulas));
  }, [cqad]);

  const dataValida = data && dayjs(data).isValid();
  const foraDoBimestre =
    dataValida &&
    bimestre?.dataInicio &&
    bimestre?.dataFim &&
    (dayjs(data).format("YYYY-MM-DD") < ymd(bimestre.dataInicio) ||
      dayjs(data).format("YYYY-MM-DD") > ymd(bimestre.dataFim));
  const podeSalvar = dataValida && !foraDoBimestre && quantAulas !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({
      ...cqad,
      bimestre: cqad.bimestre ?? bimestre,
      data: dataAlterada ? data : cqad.data,
      quantAulas: Number(quantAulas),
    });
  };

  return (
    <Dialog open={Boolean(cqad)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{cqad?.codigo ? "Editar Quantidade de Aulas" : "Nova Quantidade de Aulas"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} pt={1}>
            <TextFieldDate
              label="Data"
              value={data}
              onChange={(valor) => {
                setData(valor ? dayjs(valor) : null);
                setDataAlterada(true);
              }}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  required: true,
                  error: Boolean(foraDoBimestre),
                  helperText: foraDoBimestre
                    ? `A data deve estar entre ${dateFormat(bimestre.dataInicio)} e ${dateFormat(bimestre.dataFim)}.`
                    : " ",
                },
              }}
            />
            <TextField
              size="small"
              fullWidth
              required
              label="Quantidade de aulas"
              value={quantAulas}
              onChange={(event) => setQuantAulas(event.target.value.replace(/\D/g, "").slice(0, 2))}
              slotProps={{ htmlInput: { inputMode: "numeric" } }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CronogramaQuantAulaDiaForm;
